module.exports = __webpack_public_path__ + "img/return.61a7ef48.svg";